import type { TimelineEntry } from "@/lib/staff-api";
import { formatDateTime } from "@/lib/formatters";
import { formatCalendarDate } from "@/lib/roster";
import { describeEntry, splitAtHistoryStart } from "@/lib/staff-timeline";

function Entry({ entry }: { entry: TimelineEntry }): React.ReactElement {
  const { title, detail } = describeEntry(entry);
  const who = entry.kind === "added" ? null : entry.who;
  return (
    <li className="px-4 py-3">
      <p className="font-medium text-gray-900">{title}</p>
      {detail && <p className="text-gray-700">{detail}</p>}
      <p className="text-gray-500">
        {formatDateTime(entry.at)}
        {who && ` · ${who}`}
      </p>
    </li>
  );
}

/** An employee's history, newest first. The day recording began sits at its
 *  date, above anything older that the record already held. */
export function Timeline({ entries, startsOn }: { entries: TimelineEntry[]; startsOn: string }): React.ReactElement {
  const { recorded, before } = splitAtHistoryStart(entries, startsOn);
  return (
    <ol className="divide-y divide-gray-200 rounded-lg border border-gray-200 bg-white text-sm">
      {recorded.map((e, i) => (
        <Entry key={`r${i}`} entry={e} />
      ))}
      {before.length > 0 && (
        <li className="bg-gray-50 px-4 py-2 text-gray-600">Detailed history starts {formatCalendarDate(startsOn)}</li>
      )}
      {before.map((e, i) => (
        <Entry key={`b${i}`} entry={e} />
      ))}
    </ol>
  );
}
